/* ============================================================
   PINNACLE — THEME.JS v2
   Core interactions. FAQ accordion now lives in its section
   (sections/faq-main.liquid) — do not duplicate it here.
   ============================================================ */

'use strict';

/* ─── Scroll Reveal ─── */
const revealObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
);

document.querySelectorAll('.reveal, .img-reveal').forEach((el) => {
  revealObserver.observe(el);
});

/* ─── Sticky Header ─── */
const header = document.getElementById('site-header');

if (header) {
  let lastScrollY = window.scrollY;
  let ticking = false;

  const updateHeader = () => {
    const y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 60);
    header.classList.toggle('is-hidden', y > lastScrollY && y > 200);
    lastScrollY = y;
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) { requestAnimationFrame(updateHeader); ticking = true; }
  }, { passive: true });
}

/* ─── Mobile Navigation ─── */
/* iOS Safari ignores body overflow:hidden — use position:fixed scroll lock */
const navToggle  = document.getElementById('nav-toggle');
const navMenu    = document.getElementById('nav-menu');
const navOverlay = document.getElementById('nav-overlay');

if (navToggle && navMenu) {
  let _scrollY = 0;

  const openNav = () => {
    _scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top      = `-${_scrollY}px`;
    document.body.style.width    = '100%';
    document.body.style.overflow = 'hidden';
    navMenu.classList.add('is-open');
    navToggle.setAttribute('aria-expanded', 'true');
    if (navOverlay) navOverlay.classList.add('is-active');
  };

  const closeNav = () => {
    navMenu.classList.remove('is-open');
    navToggle.setAttribute('aria-expanded', 'false');
    document.body.style.position = '';
    document.body.style.top      = '';
    document.body.style.width    = '';
    document.body.style.overflow = '';
    window.scrollTo(0, _scrollY);
    if (navOverlay) navOverlay.classList.remove('is-active');
  };

  navToggle.addEventListener('click', () => {
    navMenu.classList.contains('is-open') ? closeNav() : openNav();
  });

  if (navOverlay) {
    navOverlay.addEventListener('click', closeNav);
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && navMenu.classList.contains('is-open')) {
      closeNav();
      navToggle.focus();
    }
  });
}

/* ─── Marquee Pause on Focus ─── */
document.querySelectorAll('.marquee__track').forEach((track) => {
  track.addEventListener('focusin',  () => { track.style.animationPlayState = 'paused'; });
  track.addEventListener('focusout', () => { track.style.animationPlayState = 'running'; });
});

/* ─── Smooth Scroll for Anchor Links ─── */
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener('click', (e) => {
    const id = anchor.getAttribute('href');
    if (id === '#') return;
    const target = document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    const top = target.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top, behavior: 'smooth' });
  });
});

/* ─── Lightweight Parallax ─── */
const parallaxEls = document.querySelectorAll('[data-parallax]');

if (parallaxEls.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  let raf;
  const tick = () => {
    const sy = window.scrollY;
    parallaxEls.forEach((el) => {
      const speed = parseFloat(el.dataset.parallax) || 0.3;
      const rect  = el.parentElement.getBoundingClientRect();
      el.style.transform = `translateY(${(rect.top + sy - sy) * speed * 0.15}px)`;
    });
    raf = null;
  };
  window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(tick); }, { passive: true });
}

/* ─── Public API ─── */
window.PINNACLE = window.PINNACLE || {};
window.PINNACLE.observeNew = (el) => {
  el.querySelectorAll('.reveal, .img-reveal').forEach((node) => {
    revealObserver.observe(node);
  });
};
